/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { AxiosError } from 'axios';
import axiosConfig, { ApiRequestType } from 'axiosConfig/axiosConfig';
import { FastDataResponse, LapAnalysisRequest } from 'models/viewModels';

class FastestLapsApi {
  async getFastestLaps(request: LapAnalysisRequest): Promise<FastDataResponse> {
    const response = new Promise<FastDataResponse>((resolve, reject) => {
      axiosConfig(ApiRequestType.StreamMetricsApi)
        .post('/rest/report/fastestLaps', request)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((error: AxiosError) => reject(new AxiosError(error.message, error.code)));
    });
    return response;
  }
}

export const fastestLapsApi = new FastestLapsApi();
